import { modalAnatomy as parts } from "@chakra-ui/anatomy"
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system"

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(parts.keys)

const variantPopup = definePartsStyle({
  header: {
    p: 0,
    lineHeight: 1.25,
    fontSize: { base: 20, md: 28, lg: 32 },
  },
})

/**
 * @see {@link https://github.com/chakra-ui/chakra-ui/blob/v2/packages/theme/src/components/modal.ts}
 */
export const Modal = defineMultiStyleConfig({
  variants: {
    popup: variantPopup,
  },
  baseStyle: {
    overlay: {
      backdropFilter: "blur(3px)",
    },
    header: {
      pt: {
        base: 4,
        sm: 6,
      },
      px: {
        base: 4,
        sm: 6,
      },
      color: "neutrals.900",
      fontSize: 18,
      lineHeight: 1.4,
    },
    closeButton: {
      top: { base: 3, md: 5 },
      insetEnd: {
        base: 4,
        md: 6,
      },
      color: "neutrals.500",
      fontSize: 12,
      _focus: {
        color: "neutrals.900",
        bg: "neutrals.100",
      },
    },
    dialog: {
      borderRadius: "2xl",
    },
    body: {
      px: {
        base: 4,
        sm: 6,
      },
      pb: {
        base: 4,
        sm: 6,
      },
    },
    footer: {
      px: {
        base: 4,
        sm: 6,
      },
      pb: {
        base: 4,
        sm: 6,
      },
    },
  },
  defaultProps: {},
})
